// React
import { useContext, useState } from "react"

// Components
import { BaseTable, Button, Card, FooterMenu, HeaderMenu, Input, Select, TableHeader, TabSection } from "components"
import { Acc, Date, Deliver, Memo, PromisedDate, SupplierId, TableSection, TaxInclusive, TradingTerm } from "../components"
import { JournalModals, Payment, Purchases } from "../EnterBill/components"
import { useProduct } from "../PurchaseOrder/components/DetailBody/utils"

// Contexts
import { DataJournalContext } from "contexts"
import { PaymentCountContext, ProbilContext, ProductContext } from "../EnterBill/contexts"

// Form
import { FormProvider, useForm } from "react-hook-form"

// Icons
import { TbPlus } from "react-icons/tb"

// Third-Party Libraries
import moment from "moment"

// Utils
import { useProject, useTaxCode } from "utils"
import { tab_list } from "../EnterBill/utils"

export default function DetailEditBill(): JSX.Element {
  // Hooks
  const count = useContext(PaymentCountContext)
  const project = useProject()
  const tax_code = useTaxCode()

  // Form
  const defaultValues = {
    address: "",
    freight: 0,
    location_id: "",
    memo: "",
    payment_term: "",
    probildetail: [],
    promise_date: moment().format("YYYY-MM-DD"),
    referensi: "",
    tax_inclusive: true,
    transaction_date: moment().format("YYYY-MM-DD")
  }
  const methods = useForm({
    defaultValues
  })

  return (
    <section className="container my-5 flex flex-col gap-2">
      <FormProvider {...methods}>
        <HeaderMenu title="DATA ENTRY | EDIT DELIVERY BILL">
          123123123
        </HeaderMenu>

        <section className="grid lg:grid-cols-3 gap-x-6 gap-y-3 items-end">
          <Select
            label="SUPPLIER"
            placeholder="Select Supplier"
          />

          <TradingTerm name="payment_term" />
          <TaxInclusive name="tax_inclusive" />
        </section>

        <Card>
          <Card.Body className="grid lg:grid-cols-2 gap-x-6 gap-y-3">
            <section className="flex flex-col gap-3">
              <Deliver
                deliver_name="location_id"
                detail_name="address"
              />

              <Memo name="memo" />
              
              <Input
                disabled
                label="LINK TO PURCHASE ID"
                value=""
              />
            </section>

            <section className="flex flex-col gap-3">
              <Date name="transaction_date" />
              <SupplierId name="referensi" />

              <PromisedDate
                disabled
                name="promise_date"
              />

              <Input
                disabled
                label="DELIVERY"
                value="#0"
              />

              <section className="flex lg:justify-end">
                <Button className="w-fit">
                  <TbPlus /> ADD REMINDER
                </Button>
              </section>
            </section>
          </Card.Body>
        </Card>

        <BaseTable>
          <TableHeader>
            <tr>
              <th>DELIVERED</th>
              <th>ITEM CODE</th>
              <th>DESCRIPTION</th>
              <th>UNIT</th>
              <th>PRICE</th>
              <th>DISC (%)</th>
              <th>TOTAL</th>
              <th>JOB</th>
              <th>TAX</th>
              <th>ACTION</th>
            </tr>
          </TableHeader>
        </BaseTable>

        <section className="grid lg:grid-cols-2 gap-x-6 gap-y-3">
          <section className="flex flex-col gap-3">
            <TableSection>
              <TableSection.Row
                label="BILL STATUS"
                value="-"
              />

              <TableSection.Row
                label="APPROVE STATUS"
                value="-"
              />

              <TableSection.Row
                label="APPROVED BY"
                value="-"
              />
            </TableSection>

          </section>

          <DataJournalContext.Provider value={{ project, tax_code }}>
            <Acc
              name={{
                detail: "probildetail",
                freight: "freight"
              }}
            />
          </DataJournalContext.Provider>
        </section>

        {!count.isLoading && (
          <ProbilContext.Provider value={{
            append: () => {}
          }}>
            <Tab />
          </ProbilContext.Provider>
        )}

      <FooterMenu
        hasCancelButton
        customElement={{ journal: <Journal /> }}
        save={{ actiontype: "save" }}
      />
      </FormProvider>
    </section>
  )
}

function Journal(): JSX.Element {
  // Hooks
  const project = useProject()
  const tax_code = useTaxCode()
  const { data, isLoading } = useProduct()

  return (
    <DataJournalContext.Provider value={{ project, tax_code }}>
      <ProductContext.Provider value={{ data, isLoading }}>
        <JournalModals />
      </ProductContext.Provider>
    </DataJournalContext.Provider>
  )
}

function Tab(): JSX.Element {
  // Vars
  const content = [Purchases, Payment, Journal]

  // Hooks
  const [currentTab, setCurrentTab] = useState<number>(0)

  return (
    <section>
      <TabSection
        activeIndex={currentTab}
        list={tab_list}
        onChangeTab={setCurrentTab}
      />

      {content.map((Element, key) => {
        if (currentTab === key) {
          return <Element key={key} />
        }

        return null
      })}
    </section>
  )
}